import { t, type StaffKey, type StaffLanguage } from './staffText'

/** The names the server gives starting roles (org.StartingRoles), as they may be stored. */
export const STARTING_ROLE_NAMES: Record<string, { en: string; az: string; ru: string }> = {
  admin: { en: 'Administrator', az: 'Administrator', ru: 'Администратор' },
  branchManager: { en: 'Branch manager', az: 'Filial rəhbəri', ru: 'Руководитель отделения' },
  supervisor: { en: 'Supervisor', az: 'Nəzarətçi', ru: 'Супервайзер' },
  counter: { en: 'Counter', az: 'Pəncərə əməkdaşı', ru: 'Сотрудник окна' },
  reception: { en: 'Reception', az: 'Qəbul əməkdaşı', ru: 'Сотрудник ресепшн' },
}

// A starting role is told apart by the key the server derives (org.StartingRoleKey);
// a role of the organisation's own has none and shows as stored.
export function roleLabel(key: string | undefined, stored: string | undefined, lang: StaffLanguage): string {
  return key ? t(`roles.builtin.${key}` as StaffKey, lang) : stored ?? ''
}

// A role name kept on a record with no key beside it (the audit trail): the owner,
// or a starting role's name in any language, is said in lang; anything else as stored.
export function storedRoleLabel(stored: string, lang: StaffLanguage): string {
  if (stored === 'superadmin') return t('common.role.superadmin', lang)
  for (const [key, names] of Object.entries(STARTING_ROLE_NAMES)) {
    if (Object.values(names).includes(stored)) return t(`roles.builtin.${key}` as StaffKey, lang)
  }
  return stored
}
